export default "# 欢迎！\n\n(要请求其他语言的翻译，请发送电子邮件 budgetqa@austintexas.gov。)\n\n奥斯汀市想知道您对预算优先投资领域的看法。您的意见对城市的领导班子很重要，有助于他们制定未来的资金分配决策。立即参与调查！\n\n在投票前，请验证您不是机器人：";